import { ChangeEvent, FormEvent, FunctionComponent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RivalsButton from "rivals/components/shared/Button";
import FormInput from "rivals/components/shared/Form/TextInput";
import { InputType } from "rivals/components/shared/Form/TextInput/types";
import {
  removePromotion,
  validatePromoCode
} from "rivals/redux/promotion/actions";
import {
  getPromoCodeError,
  getPromotion
} from "rivals/redux/promotion/selectors";
import { getSubmitting } from "rivals/redux/user/selectors";
import styles from "./PromotionInput.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const PromotionInput: FunctionComponent<OwnProps> = ({
  planType,
  promoCodeValue,
  readOnly = false,
  referAFriendCode,
  selectedSite,
  setPromoCode,
  subscriptionId
}) => {
  const dispatch = useDispatch();
  const promotion = useSelector(getPromotion);
  const promoCodeError = useSelector(getPromoCodeError);
  const submitting = useSelector(getSubmitting);

  const { applyCode, promoCode, promoSuccessful, removeCode } = strings;

  useEffect(() => {
    return (): void => {
      dispatch(removePromotion());
    };
  }, []);

  const validate = (): void => {
    if (!promoCodeValue || (selectedSite && !selectedSite.subscribable)) {
      return;
    }

    if (selectedSite) {
      dispatch(
        validatePromoCode({
          code: promoCodeValue,
          planType: planType,
          referAFriendCode: referAFriendCode,
          siteId: selectedSite.id,
          subscriptionId: subscriptionId
        })
      );
    }
  };

  useEffect(validate, [planType, selectedSite]);

  return (
    <>
      {selectedSite && (
        <form
          className={styles.promoCodeForm}
          onSubmit={(e: FormEvent): void => {
            e.preventDefault();
            if (!promotion) {
              return validate();
            }
            dispatch(removePromotion());
            setPromoCode("");
          }}
        >
          <div className={styles.promoCodeInputBox}>
            <FormInput
              data="promotion-code"
              disabled={!!promotion || submitting}
              feedback={promoCodeError}
              infoPrompt={promotion && promoSuccessful}
              label={promoCode}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                setPromoCode(e.target.value);
              }}
              readOnly={readOnly}
              required={false}
              type={InputType.TEXT}
              value={promoCodeValue}
            />
          </div>
          <RivalsButton
            borderColor="transparent"
            buttonText={promotion ? removeCode : applyCode}
            className={styles.promoCodeButton}
            data="promotion-apply"
            disabled={submitting || !selectedSite.subscribable || readOnly}
            inverted
            size="small"
            type="submit"
          />
        </form>
      )}
    </>
  );
};

export default PromotionInput;
